export const UNIVERSAL = 'UNIVERSAL';
export const PARTICULAR = 'PARTICULAR';
